
export default class BankAccountCreateMemberRequestModel {
    public inviteeMemberEmailAddress: string = '';
    public roleTypeId: number = 0;
}

